import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  // set to true spinner will show when making a service call
  // set to false spinner will NOT show during the service call
  DISPLAY_SPINNER = true;

  // Default of 1000ms 1 seconds. If a service call takes longer than
  // SPINNER_THRESHOLD value the spinner will be displayed other wise
  // it will not be displayed. Also DISPLAY_SPINNER must be set to TRUE
  // for this value to take effect.
  private _spinner_threshold = 500;
  private _spinner_timeout = 20000;


  // When using security and need login screen/link to appear
  // on the Main Menu enable either the JWT or BASIC_AUTH

  private ENABLE_JWT = false;


  // INTRANET can use this cookie to extract the USER_ID
  private UID_COOKIE_NAME = "HighWireUserUID";


  endPoints = [
    {URI: '/eblarc/service/binder/saml', KEY: 'saml' },
    {URI: '/eblarc/service/binder/payment', KEY: 'payment'},
    {URI: '/eblarc/service/binder/requestabill', KEY: 'requestabill'},
    {URI: '/secinn/rest/userAdmin/unLockAccount', KEY: 'unlockUser'},
    {URI: '/secinn/rest/userServices/findUserByGroupDN', KEY: 'usersByGroup'},
    {URI: '/secinn/rest/userAdmin/activateUser',KEY: 'activateUser'},
    {URI: '/secinn/rest/userAdmin/suspendUser',KEY: 'suspendUser'},
    {URI: '/secinn/rest/userServices/getExternalGroupNames',KEY: 'getExternalGroupNames'},
    {URI: 'https://apiintdev.hmhs.com:8087/api/oauth/token', KEY: 'OAuthUri'},
    {URI: 'https://apiintdev.hmhs.com:8087/api/oauth/token', KEY: 'RefreshOAuthUri'},
    {URI: 'https://wasintertenv6.highmark.com/eblarc/service/binder/saml', KEY: 'OAuthUri'},
    {URI: 'https://cdssotest.highmark.com/hmkauth/epay/sbeffmlogout', KEY: 'deleteTestCookie'},
    {URI: 'https://cdsso.highmark.com/hmkauth/epay/sbeffmlogout', KEY: 'deleteCookie'},
    {URI: '/eblarc/service/v1/SubmitPaymentService/sendAdverseNotification', KEY: 'adversenotification' },
    {URI: '/eblarc/service/v1/SubmitPaymentService/acknowledgement', KEY: 'sendAdverseAcknowledgement'},
    {URI: '/eblarc/service/binder/saml/hsDetails', KEY: 'hsDetails' },
    {URI: '/eblarc/service/binder/saml/binderDetails', KEY: 'nysbeuserDetails' }
  ];


  constructor( ) {

  }

  getUidCookieName(): string {
    return this.UID_COOKIE_NAME
  }

  /**
   * Get the uri based on the key
   * @param findKEY key to fetch uri from
   */
  getURI(findKEY: string): string {
    const val = this.endPoints.find(x => x.KEY === findKEY);
    return val.URI;
  }


  getDisplaySpinner(): boolean {
    return this.DISPLAY_SPINNER;
  }

  public get spinnerThreshold(): number {
    return this._spinner_threshold;
  }

  public get spinnerTimeout(): number {
    return this._spinner_timeout;
  }




  public isSecurityEnabled() : boolean {

    return( this.ENABLE_JWT );

  }




}
